<div class="table-container" [class.row-selection-enabled]="enableRowSelection">
  <button
    class="hidden-export-button"
    (click)="exportTable('csv')"
    id="table-upload-csv"
  ></button>
  <button
    class="hidden-export-button"
    (click)="exportTable('pdf')"
    id="table-upload-pdf"
  ></button>
  <table>
    <colgroup>
      <col
        *ngIf="enableRowSelection"
        style="width: 56px; min-width: 56px; max-width: 56px"
      />
      <ng-container *ngFor="let col of columns; let i = index">
        <col *ngIf="columns.length <= 8" />
        <col *ngIf="columns.length > 8" />
      </ng-container>
      <col
        *ngIf="actionTemplate"
        class="mat-column-actions"
        style="width: 110px; min-width: 110px; max-width: 110px"
      />
    </colgroup>

    <thead>
      <tr>
        <th *ngIf="enableRowSelection">
          <input
            type="checkbox"
            [checked]="selectAllChecked"
            (change)="toggleSelectAll()"
          />
        </th>
        <th
          *ngFor="let col of columns"
          class="sortable-th"
          [class.status-column]="
            col === 'status' ||
            col === 'student status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
          [class.mat-column-status]="
            col === 'status' ||
            col === 'student status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
        >
          <div
            class="header-content"
            [class.status-header]="
              col === 'status' ||
              col === 'student status' ||
              col === 'registrationStatus' ||
              col === 'attendanceStatus'
            "
          >
            <span class="header-label">{{ formatColumnHeader(col) }}</span>
            <button
              *ngIf="isColumnSortable(col)"
              class="sort-btn"
              [class.asc]="getSortState(col) === 'asc'"
              [class.desc]="getSortState(col) === 'desc'"
              (click)="cycleSort(col)"
              type="button"
              [attr.aria-label]="'Sort ' + formatColumnHeader(col)"
            >
              <img
                class="sort-image"
                [src]="getSortImage(getSortState(col))"
                alt="Sort"
              />
            </button>
          </div>
        </th>
        <th *ngIf="actionTemplate" class="actions-header mat-column-actions">
          {{ actionButtonName || "Actions" }}
        </th>
      </tr>
    </thead>

    <tbody
      *ngIf="!loading"
      [class.fade-out]="isAnimating"
      [class.fade-in]="!isAnimating"
    >
      <tr
        *ngFor="let row of paginatedData; let i = index"
        [class.invalid-row]="!isRowValid(row) && enableRowSelection"
        (click)="onRowClick(row, $event)"
        [class.clickable-row]="
          rowClick.observers.length > 0 && !row.isDownloading
        "
        [class.downloading-row]="row.isDownloading"
      >
        <td *ngIf="enableRowSelection">
          <input
            type="checkbox"
            [checked]="isRowSelected(row)"
            (change)="toggleRowSelection(row)"
            [disabled]="!isRowValid(row)"
            [class.invalid-checkbox]="!isRowValid(row)"
            matTooltip="Invalid email or phone number"
            [matTooltipDisabled]="isRowValid(row)"
          />
        </td>

        <td
          *ngFor="let col of columns"
          [class.status-column]="
            col === 'status' ||
            col === 'student status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
          [class.mat-column-status]="
            col === 'status' ||
            col === 'student status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
        >
          <ng-container [ngSwitch]="col">
            <ng-container *ngSwitchCase="'status'">
              <!-- Selectable dropdown (CSQ event student list) -->
              <div
                class="status-label-dropdown-wrapper"
                *ngIf="useEventStatusLabels"
              >
                <span
                  [ngClass]="getEventStatusClass(row.status)"
                  class="status-label-badge"
                  (click)="toggleStatusLabelDropdown(row, $event)"
                >
                  {{ getEventStatusLabel(row.status) }}
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    style="flex-shrink: 0"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <div
                  class="status-label-dropdown"
                  *ngIf="openStatusDropdownRowId === row.id"
                >
                  <div
                    class="status-label-item interested-item"
                    *ngIf="getEventStatusLabel(row.status) !== 'Interested'"
                    (click)="onSelectStatusLabel(row, 'Interested', $event)"
                  >
                    Interested
                  </div>
                  <div
                    class="status-label-item approved-item"
                    *ngIf="getEventStatusLabel(row.status) !== 'Approved'"
                    (click)="onSelectStatusLabel(row, 'Approved', $event)"
                  >
                    Approved
                  </div>
                  <div
                    class="status-label-item unapproved-item"
                    *ngIf="getEventStatusLabel(row.status) !== 'Unapproved'"
                    (click)="onSelectStatusLabel(row, 'Unapproved', $event)"
                  >
                    Unapproved
                  </div>
                </div>
              </div>

              <!-- Static badge (all other usages) -->
              <span
                *ngIf="!useEventStatusLabels"
                [class.disabled]="
                  row.eventTypeName === 'Teacher Work Experience' ||
                  row.eventTypeName === 'Student External Event'
                "
                [ngClass]="
                  row.statusClass
                    ? row.statusClass
                    : row.status === 'Approved'
                      ? 'status-active'
                      : row.status === 'Rejected' ||
                          row.status === 'Declined'
                        ? 'status-inactive'
                        : row.status === 'Unregistered' ||
                            row.status === 'Not Registered'
                          ? 'status-upcoming'
                          : row.status === 'Active'
                            ? 'status-active'
                            : row.status === 'Inactive'
                              ? 'status-inactive'
                              : row.status === 'Already Held'
                                ? 'status-already-held'
                                : row.status === 'Upcoming'
                                  ? 'status-upcoming'
                                  : row.status === 'On Hold'
                                    ? 'status-on-hold'
                                    : row.status === 'Ongoing' ||
                                        row.status === 'On Today'
                                      ? 'status-on-today'
                                      : row.status === 'Event Completed' ||
                                          row.status === 'Completed'
                                        ? 'completed-text'
                                        : row.status === 'Event Cancelled' ||
                                            row.status === 'Cancelled'
                                          ? 'cancelled-text'
                                          : row.status === 'Deleted'
                                            ? 'cancelled-text'
                                            : row.status === 'Draft'
                                              ? 'status-draft'
                                              : row.status === 'Registered'
                                                ? 'reg-status'
                                                : row.status === 'Attended'
                                                  ? 'reg-status'
                                                  : row.status ===
                                                      'UnregisteredAddedManually'
                                                    ? 'status-active'
                                                    : row.status ===
                                                        'NewNonOnboarded'
                                                      ? 'status-active'
                                                      : row.status ===
                                                          'Awaiting Approval'
                                                        ? 'awaiting-status'
                                                        : 'status-pending'
                "
                (click)="
                  row.status === 'TeacherApproved' ||
                  row.status === 'Registered' ||
                  row.status === 'TeacherRejected' ||
                  row.status === 'UnregisteredAddedManually' ||
                  row.status === 'NewNonOnboarded' ||
                  row.eventTypeName === 'Teacher Work Experience' ||
                  row.eventTypeName === 'Student External Event'
                    ? ''
                    : onStatusClick(row, $event)
                "
                [ngStyle]="{
                  cursor: row?.isStatusClickable ? 'pointer' : 'default',
                }"
              >
                {{
                  useEventStatusLabels && row.status === "TeacherApproved"
                    ? "Approved"
                    : useEventStatusLabels &&
                        (row.status === "TeacherReviewPending" ||
                          row.status === "Pending" ||
                          row.status === "NewNonOnboarded")
                      ? "Interested"
                      : useEventStatusLabels && row.status === "TeacherRejected"
                        ? "Unapproved"
                        : row.status === "UnregisteredAddedManually"
                          ? "Unregistered Added Manually"
                          : row.status === "NewNonOnboarded"
                            ? "New Non Onboarded"
                            : row.status === "PreRegistered"
                              ? "Pre Registered"
                              : row.status === "ConsentDeclined"
                                ? "Parent Declined"
                                : row.status === "Rejected"
                                  ? "Declined"
                                  : row.status
                }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'registrationStatus'">
              <span
                [ngClass]="
                  row.registrationStatus === 'Registered'
                    ? 'reg-success'
                    : row.registrationStatus === 'Not Registered'
                      ? 'reg-inavalid'
                      : 'status-pending'
                "
                (click)="onStatusClick(row, $event)"
              >
                {{ row.registrationStatus }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'attendanceStatus'">
              <span
                [ngClass]="
                  row.attendanceStatus === 'Present'
                    ? 'status-active'
                    : row.attendanceStatus === 'Absent'
                      ? 'status-inactive'
                      : 'status-pending'
                "
                (click)="onStatusClick(row, $event)"
              >
                {{ row.attendanceStatus }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'student status'">
              <span
                *ngIf="row['student status'] && row['student status'] !== '-'; else noStudentStatus"
                [ngClass]="
                  row['student status'] === 'Registered'
                    ? 'status-active'
                    : row['student status'] === 'Parent Declined'
                      ? 'cancelled-text'
                      : 'status-inactive'
                "
              >
                {{ row['student status'] }}
              </span>
              <ng-template #noStudentStatus>-</ng-template>
            </ng-container>

            <ng-container *ngSwitchCase="'admin approval'">
              <span
                [ngClass]="
                  row['admin approval'] === 'Pending'
                    ? 'status-pending'
                    : row['admin approval'] === 'Approved'
                      ? 'status-active'
                      : 'status-inactive'
                "
                (click)="onStatusClick(row['admin approval'], $event)"
                [ngStyle]="{
                  cursor: row?.isAdminClickable ? 'pointer' : 'default',
                }"
              >
                {{ row["admin approval"] }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'teacher approval'">
              <span
                [ngClass]="
                  row['teacher approval'] === 'Pending'
                    ? 'status-pending'
                    : row['teacher approval'] === 'Approved'
                      ? 'status-active'
                      : 'status-inactive'
                "
                (click)="onStatusClick(row['teacher approval'], $event)"
                [ngStyle]="{
                  cursor: row?.isTeacherClickable ? 'pointer' : 'default',
                }"
              >
                {{ row["teacher approval"] }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'approval status'">
              <span
                [ngClass]="
                  row['approval status'] === 'Approved'
                    ? 'status-active'
                    : row['approval status'] === 'Rejected'
                      ? 'status-inactive'
                      : 'status-pending'
                "
                (click)="onApprovalStatusClick(row, $event)"
              >
                {{ row["approval status"] }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'event status'">
              <!-- Interactive dropdown when useEventStatusLabels (teacher view) -->
              <div
                class="status-label-dropdown-wrapper"
                *ngIf="useEventStatusLabels"
              >
                <span
                  [ngClass]="getEventStatusClass(row['event status'])"
                  class="status-label-badge"
                  (click)="toggleStatusLabelDropdown(row, $event)"
                >
                  {{ getEventStatusLabel(row["event status"]) }}
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    style="flex-shrink: 0"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <div
                  class="status-label-dropdown"
                  *ngIf="openStatusDropdownRowId === row.id"
                >
                  <div
                    class="status-label-item interested-item"
                    *ngIf="
                      getEventStatusLabel(row['event status']) !== 'Interested'
                    "
                    (click)="onSelectStatusLabel(row, 'Interested', $event)"
                  >
                    Interested
                  </div>
                  <div
                    class="status-label-item approved-item"
                    *ngIf="
                      getEventStatusLabel(row['event status']) !== 'Approved'
                    "
                    (click)="onSelectStatusLabel(row, 'Approved', $event)"
                  >
                    Approved
                  </div>
                  <div
                    class="status-label-item unapproved-item"
                    *ngIf="
                      getEventStatusLabel(row['event status']) !== 'Unapproved'
                    "
                    (click)="onSelectStatusLabel(row, 'Unapproved', $event)"
                  >
                    Unapproved
                  </div>
                </div>
              </div>
              <!-- Static badge for other views -->
              <span
                *ngIf="!useEventStatusLabels"
                [ngClass]="
                  row['event status'] === 'Approved'
                    ? 'status-active'
                    : row['event status'] === 'Rejected'
                      ? 'status-inactive'
                      : 'status-pending'
                "
                (click)="onApprovalStatusClick(row, $event)"
              >
                {{ row["event status"] }}
              </span>
            </ng-container>

            <ng-container *ngSwitchCase="'attended'">
              <div (click)="$event.stopPropagation()">
                <label
                  class="toggle-switch"
                  [class.disabled]="!isToggleEnabled(row)"
                >
                  <input
                    type="checkbox"
                    [checked]="row.attended"
                    [disabled]="!isToggleEnabled(row)"
                    (change)="onToggleChange(row, $event)"
                  />
                  <span class="slider"></span>
                </label>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'Date & time'">
              <div class="date-time-container">
                <div class="date">{{ row["Date & time"]?.date || "-" }}</div>
                <div class="time">{{ row["Date & time"]?.time || "" }}</div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'media consent'">
              <div (click)="$event.stopPropagation()">
                <div class="d-flex align-items-center gap-3">
                  <label
                    class="media-toggle-switch static"
                    [class.approved]="isConsentApproved(row['media consent'])"
                    [class.rejected]="
                      getConsentStatusClass(row['media consent']) === 'rejected'
                    "
                  >
                    <input
                      type="checkbox"
                      [checked]="isConsentApproved(row['media consent'])"
                      disabled
                      readonly
                      (click)="$event.preventDefault()"
                    />
                    <span class="slider"></span>
                  </label>
                  <div
                    *ngIf="isConsentApproved(row['media consent'])"
                    class="media-download-button"
                    (click)="onDownload(row, $event, true)"
                  >
                    <img src="assets/images/download-media.svg" />
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'parent consent'">
              <div class="parent-consent-control">
                <label
                  class="media-toggle-switch"
                  [ngClass]="
                    getConsentStatusClass(
                      row.parentApprovalStatus ?? row['parent consent']
                    )
                  "
                  (click)="$event.stopPropagation()"
                >
                  <input
                    type="checkbox"
                    [checked]="
                      isConsentApproved(
                        row.parentApprovalStatus ?? row['parent consent']
                      )
                    "
                    [disabled]="true"
                    readonly
                    (click)="$event.preventDefault()"
                  />
                  <span class="slider"></span>
                </label>

                <div
                  class="media-download-button"
                  [class.disabled]="
                    !isConsentApproved(
                      row.parentApprovalStatus ?? row['parent consent']
                    )
                  "
                  [class.download-available]="
                    isConsentApproved(
                      row.parentApprovalStatus ?? row['parent consent']
                    )
                  "
                  [style.cursor]="
                    isConsentApproved(
                      row.parentApprovalStatus ?? row['parent consent']
                    )
                      ? 'pointer'
                      : 'default'
                  "
                  [ngClass]="
                    getConsentStatusClass(
                      row.parentApprovalStatus ?? row['parent consent']
                    )
                  "
                  (click)="
                    isConsentApproved(
                      row.parentApprovalStatus ?? row['parent consent']
                    )
                      ? onDownload(row, $event, true)
                      : $event.stopPropagation()
                  "
                >
                  <ng-container
                    *ngIf="row.isDownloading; else parentConsentIcon"
                  >
                    <div class="down-spinner"></div>
                  </ng-container>
                  <ng-template #parentConsentIcon>
                    <img
                      src="assets/images/download-media.svg"
                      alt="download"
                    />
                  </ng-template>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'Partnership School/s contact'">
              <div class="date-time-container">
                <ng-container
                  *ngIf="
                    row['Partnership School/s contact']?.length;
                    else noSchoolContact
                  "
                >
                  <div
                    *ngFor="
                      let contact of row['Partnership School/s contact'];
                      let last = last
                    "
                  >
                    <div class="date">
                      {{ contact.name || "-"
                      }}{{ !contact.email && !last ? "," : "" }}
                    </div>
                    <div class="time" *ngIf="contact.email">
                      {{ contact.email }}{{ last ? "" : "," }}
                    </div>
                  </div>
                </ng-container>
                <ng-template #noSchoolContact>-</ng-template>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'notes'">
              <div class="notes-wrapper">
                <span class="note-text" [title]="row?.notes">
                  {{ row?.notes ? row?.notes : "-" }}
                </span>
                <span class="edit-icon" (click)="onEditNotes(row, $event)">
                  <img src="../../../../assets/images/pencil-02.svg" />
                </span>

                <div
                  class="note-editor-dropdown"
                  *ngIf="currentEditingRow === row"
                >
                  <div class="note-editor-header">
                    <h3>Edit Notes</h3>
                    <div class="cross-icon" (click)="closeNoteEditor()">
                      <img
                        src="assets/images/cross-icon.svg"
                        class="cross-icon-img"
                      />
                    </div>
                  </div>
                  <div class="note-editor-content" [class.error]="notesError">
                    <textarea
                      [(ngModel)]="editedNote"
                      (ngModelChange)="onNoteChange($event)"
                      placeholder="Enter your notes here..."
                      class="note-textarea"
                      rows="4"
                      maxlength="1000"
                    ></textarea>
                    <div class="character-count">
                      {{ editedNote.length || 0 }}/1000
                    </div>
                  </div>
                  <p *ngIf="notesError" class="notesError">
                    Please enter a note.
                  </p>
                  <div class="note-editor-actions">
                    <button class="btn-cancel" (click)="closeNoteEditor()">
                      Cancel
                    </button>
                    <button class="btn-save" (click)="saveNote()">Save</button>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'colour'">
              <div class="notes-wrapper">
                <span
                  class="color-bar"
                  [title]="row?.notes"
                  [style.backgroundColor]="row?.colour"
                  [style.padding]="'12px'"
                  [style.borderRadius]="'50px'"
                >
                </span>
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="'school'">
              <div *ngIf="row['_schoolsList']?.length; else noSchool" class="school-list">
                <span *ngFor="let s of row['_schoolsList']; let last = last" class="school-item">{{ s }}{{ last ? '' : ',' }}</span>
              </div>
              <ng-template #noSchool>-</ng-template>
            </ng-container>

            <ng-container *ngSwitchCase="'student name'">
              <span
                class="link-text student-name-cell"
                style="cursor: pointer"
                (click)="onCellValueClick(row, col, $event)"
              >
                {{ row[col] ?? "-" }}
                <span
                  *ngIf="row.isTeacherVerified"
                  class="verified-tick-badge"
                  [title]="'Verified by ' + (row.teacherVerifiedByName || 'teacher')"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 24 24" fill="white" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </span>
            </ng-container>

            <ng-container *ngSwitchDefault>
              <span
                *ngIf="isClickableColumn(col); else defaultCellValue"
                class="link-text"
                style="cursor: pointer"
                (click)="onCellValueClick(row, col, $event)"
              >
                {{ row[col] ?? "-" }}
              </span>
              <ng-template #defaultCellValue>
                {{ row[col] ?? "-" }}
              </ng-template>
            </ng-container>
          </ng-container>
        </td>

        <td *ngIf="actionTemplate" class="actions-cell mat-column-actions">
          <ng-container
            *ngTemplateOutlet="actionTemplate; context: { $implicit: row }"
          ></ng-container>
        </td>
      </tr>

      <tr *ngIf="safeData.length === 0">
        <td [attr.colspan]="getColspan()" class="no-data-cell">
          No data available
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="loading">
      <tr>
        <td [attr.colspan]="getColspan()" class="no-data-cell">
          <span class="loading-text">Loading data...</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="pagination-container" *ngIf="!loading && safeData.length > 0">
  <div class="pagination-info">
    <span
      >Showing {{ startRecord }} to {{ endRecord }} of
      {{ totalListItem || safeData.length }} entries</span
    >
  </div>
  <div class="pagination" *ngIf="totalPages > 1">
    <button
      class="pagination-btn"
      (click)="goToPreviousPage()"
      [disabled]="!hasPreviousPage || isAnimating"
      [class.disabled]="!hasPreviousPage || isAnimating"
      title="Previous Page"
    >
      ‹
    </button>
    <ng-container *ngFor="let page of paginationDisplay">
      <button
        *ngIf="page !== '...'"
        class="pagination-btn page-number"
        [class.active]="currentPage === page"
        (click)="goToPage(+page)"
        [disabled]="isAnimating"
        [title]="'Go to page ' + page"
      >
        {{ page }}
      </button>
      <span
        *ngIf="page === '...'"
        class="pagination-btn disabled"
        style="pointer-events: none"
        >...</span
      >
    </ng-container>
    <button
      class="pagination-btn"
      (click)="goToNextPage()"
      [disabled]="!hasNextPage || isAnimating"
      [class.disabled]="!hasNextPage || isAnimating"
      title="Next Page"
    >
      ›
    </button>
  </div>
</div>
